import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BrandModeService } from '@services/brandmode.service';
import { ManualConfigService } from '@services/manual-config.service';
import { ModelModel } from '@models/api-models/model';
import { ComponentVariantModel } from '@models/component-variant';
import { ConfigurationModel } from '@models/configuration';
import { ModelSizeModel } from '@models/model-size';
import { SetManualDefaultModel, SetManualDefaultVariantModel } from '../../../../_models/set-manual-default-model';

@Component({
    selector: 'set-default-button',
    templateUrl: 'set-default-button.html',
    styleUrls: ['./set-default-button.scss'],
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class SetDefaultButtonComponent implements OnChanges, OnInit {
	@Input() configuration: ConfigurationModel | null;
	@Input() modelSize?: ModelSizeModel;
	@Input() model?: ModelModel;
	@Input() variants?: Array<ComponentVariantModel>;
	@Input() originalVariants: Array<ComponentVariantModel> | null;
	@Output() updateOriginalVariants: EventEmitter<Array<ComponentVariantModel>> = new EventEmitter();

	public originalModelsize: ModelSizeModel;
	public isDefault: boolean = true;

	constructor(private brandModeService: BrandModeService, private manualConfigService: ManualConfigService,
	) { }

	ngOnInit() {
		this.originalModelsize = Object.assign(ModelSizeModel, this.modelSize);
	}

	public async setAsDefault() {
		const variants = this.variants?.filter(x => !x.Optional).map(x => new SetManualDefaultVariantModel(x.Id, x.VariantSize ? x.VariantSize.Id : null, x.VariantColor ? x.VariantColor.Id : null, x.VariantColor ? x.VariantColor.Color?.Id : null));
		const model = new SetManualDefaultModel(this.modelSize?.Id, this.configuration?.ModelConfigId, this.model?.Id, this.brandModeService.currentBrandValue(), variants);
		await this.manualConfigService.setManualDefaults(model);
		this.updateOriginalVariants.emit(this.variants);
		this.isDefault = true;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (this.originalVariants && this.originalModelsize) {
			const variantsChanged = !ComponentVariantModel.IsEqualVariants(this.variants, this.originalVariants);
			const modelSizeChanged = this.modelSize?.Code != this.originalModelsize.Code;

			this.isDefault = !variantsChanged && !modelSizeChanged;
		}
	}
}
